import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    const $link = $('.link-with-icon, .content-block--secondary-cta .content-block__cta, .content-header-link');
    const icon = '<svg><use class="icon-use" xlink:href="#icon-chevron-right"></use></svg>';
    $link.append(icon);
});
